import { IRoute } from '../types/route';
import Home from '../component/page/Home';
import { RouteConstants } from '@/constants/route-constant';
import Check from '../component/page/Check';
import BatchCheck from '../component/page/BatchCheck';
import Team from '../component/page/Team';
import ConfigureFeatures from '../component/page/ConfigureFeatures';
import CreateRule from '../component/page/CreateRule';
import EditRule from '../component/page/EditRule';
import DataExtraction from '../component/page/DataExtraction';

const privateRoutes: IRoute[] = [
  { path: RouteConstants.ROUTE_HOME, element: <Home /> },
  { path: RouteConstants.ROUTE_CHECK, element: <Check /> },
  { path: RouteConstants.ROUTE_BATCH_CHECK, element: <BatchCheck /> },
  {
    path: RouteConstants.ROUTE_TEAM_CONFIGURE_FEATURES,
    element: <ConfigureFeatures />,
  },
  { path: RouteConstants.ROUTE_TEAM, element: <Team /> },
  {
    path: RouteConstants.ROUTE_DATA_EXTRACTION,
    element: <DataExtraction />,
  },
  { path: RouteConstants.ROUTE_DASHBOARD_CREATE_RULE, element: <CreateRule /> },
  { path: RouteConstants.ROUTE_DASHBOARD_EDIT_RULE, element: <EditRule /> },
];

export default privateRoutes;
